module.exports = __webpack_public_path__ + "img/menu-icon.82b4a5b6.svg";